import { DynamicSchemaService } from './dynamic-schema.service';
import { DynamicSchemaStore } from './dynamic-schema.store';
import { DynamicSchemaQuery } from './dynamic-schema.query';
import { Schema } from '../../squidex/models/schema.model';
import { Field } from '../../squidex/models/field.model';
import { Observable } from 'rxjs';
import { DynamicSchemaModel } from './dynamic-schema.model';
import { SchemasFactory } from '../..';
import { TranslateService } from '@ngx-translate/core';
import { SchemaProperty } from '../../squidex';
import { map } from 'rxjs/operators';

export class DynamicSchemaFacade {
  service: DynamicSchemaService; //TODO: make it static
  store: DynamicSchemaStore; //TODO: make it static
  query: DynamicSchemaQuery; //TODO: make it static

  constructor(
    private readonly schemaName: string,
    private readonly schemasFactory: SchemasFactory,
    private readonly translateService: TranslateService) {
    this.service = new DynamicSchemaService(schemasFactory.getSchemaService(schemaName));
    this.store = new DynamicSchemaStore(schemaName);
    this.query = new DynamicSchemaQuery(this.store);
  }

  getSchemaDefinition(): Observable<DynamicSchemaModel> {
    return this.service.getSchemaDefinition();
  }

  fieldExist(fieldName: string): Observable<boolean> {
    return this.getSchemaDefinition().pipe(map(schema => {
      return schema.fields.some(field => field.name === fieldName);
    }));
  }

  createMe(properties: SchemaProperty, category: string, isSingleton: boolean = false): Observable<DynamicSchemaModel> {
    const schema = new Schema();

    schema.name = this.schemaName.toLocaleLowerCase();
    schema.properties = properties;
    schema.isSingleton = isSingleton;
    schema.category = category;

    return this.schemasFactory.createSchema(schema);
  }

  updateProperties(properties: SchemaProperty): Observable<DynamicSchemaModel> {
    return this.service.updateSchemaProperties(properties).pipe(map(schema => {
      this.store.update({ properties: schema.properties });
      return schema;
    }));
  }

  addField(field: Field): Observable<DynamicSchemaModel> {
    return this.service.addField(field).pipe(map(schema => {
      this.store.update({ fields: schema.fields });
      return schema;
    }));
  }

  updateField(field: Field, fieldId?: number): Observable<DynamicSchemaModel> {
    // fix for assets
    if (field.properties && field.properties.fieldType === 'Assets') {
      if (field.properties.minItems == 0) {
        field.properties.minItems = 0;
        field.properties.maxItems = 1;
      }
      else {
        field.properties.minItems = null;
        field.properties.maxItems = null;
      }
    }
    return this.service.updateField(field, fieldId).pipe(map(schema => {
      this.store.update({ fields: schema.fields });
      return schema;
    }));
  }

  deleteField(fieldId: number, force: boolean = false): Observable<DynamicSchemaModel> {
    //TODO: manage soft & hard delete with force
    return this.service.deleteField(fieldId, force).pipe(map(schema => {
      this.store.update({ fields: schema.fields });
      return schema;
    }));
  }

  desableField(fieldId: number): Observable<DynamicSchemaModel> {
    return this.service.disableField(fieldId).pipe(map(schema => {
      this.store.update({ fields: schema.fields });
      return schema;
    }));

  }

  enableField(fieldId: number): Observable<DynamicSchemaModel> {
    return this.service.enableField(fieldId).pipe(map(schema => {
      this.store.update({ fields: schema.fields });
      return schema;
    }));
  }

  reorderFields(fieldIds: number[]): Observable<DynamicSchemaModel> {
    return this.service.reorderField(fieldIds).pipe(map(schema => {
      this.store.update({ fields: schema.fields });
      return schema;
    }));
  }
}
